import React, { useState } from "react";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Sparkles, Loader2, Zap, ArrowRight } from "lucide-react";
import api from "@/lib/api";

const PRIORITY_TINT = { Critical: "bg-red-50 text-red-700 border-red-200", High: "bg-amber-50 text-amber-800 border-amber-200", Normal: "bg-blue-50 text-blue-700 border-blue-200", Low: "bg-slate-100 text-slate-600 border-slate-200" };

export const StartMyDay = () => {
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [plan, setPlan] = useState(null);

  const run = async () => {
    setOpen(true); setLoading(true); setPlan(null);
    try { const { data } = await api.post("/ai/start-my-day"); setPlan(data); }
    catch { setPlan({ summary: "Could not generate plan right now.", plan: [] }); }
    finally { setLoading(false); }
  };

  return (
    <>
      <Button data-testid="start-my-day-button" onClick={run} className="aurelo-gradient text-white h-11 px-5 shadow-[0_10px_24px_rgba(59,130,246,0.18)]">
        <Zap className="h-4 w-4 mr-1.5" />Start My Day
      </Button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="max-w-lg">
          <DialogHeader><DialogTitle className="flex items-center gap-2"><Sparkles className="h-5 w-5 text-[#7C3AED]" />Today's Revenue Plan</DialogTitle></DialogHeader>
          {loading && <div className="py-10 flex flex-col items-center gap-3 text-slate-500"><Loader2 className="h-6 w-6 animate-spin text-[#7C3AED]" /><span className="text-sm">Aurelo AI is prioritizing your day…</span></div>}
          {plan && !loading && (
            <div className="space-y-3">
              <p className="text-sm text-slate-500">{plan.summary}</p>
              <div className="space-y-2 max-h-[50vh] overflow-y-auto">
                {(plan.plan || []).map((p, i) => (
                  <div key={i} className="rounded-xl border border-slate-200 p-3.5">
                    <div className="flex items-start justify-between gap-2">
                      <div className="flex items-center gap-2"><span className="h-6 w-6 rounded-lg aurelo-gradient text-white text-xs font-bold flex items-center justify-center shrink-0">{i + 1}</span><span className="text-sm font-semibold text-slate-900">{p.title}</span></div>
                      <span className={`text-[10px] font-bold rounded-full border px-2 py-0.5 shrink-0 ${PRIORITY_TINT[p.priority] || PRIORITY_TINT.Normal}`}>{p.priority}</span>
                    </div>
                    <p className="text-xs text-slate-500 mt-1.5">{p.reason}</p>
                    <div className="flex items-center justify-between mt-2">
                      <span className="text-xs font-semibold text-emerald-600">{p.estimated_impact}</span>
                      <span className="text-[11px] text-slate-400">{p.confidence}% confidence</span>
                    </div>
                    {p.suggested_action && <div className="mt-2 text-xs text-[#7C3AED] font-medium flex items-center gap-1"><ArrowRight className="h-3 w-3" />{p.suggested_action}</div>}
                  </div>
                ))}
              </div>
            </div>
          )}
        </DialogContent>
      </Dialog>
    </>
  );
};
